import React from "react";

export default function Loader() {
  return (
    <>
      <div className="aximo-preloader-wrap">
        <div className="aximo-preloader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </>
  );
}
